export default __webpack_public_path__ + "static/media/pte_1.7747b86a.png";